/**
 * Search JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

// Uncomment when the autocomplete functionality is implemented.
// import 'jquery-ui-dist/jquery-ui.js';

/**
 * Class Search
 */
export default class Search {

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        // Search form desktop for autocomplete.
        this.searchFormDesktop  = $( '#nav--desktop__search__form' );
        this.searchFormInput    = $( '#nav--desktop__search__form__input' );
    }

    /**
     * Search autocomplete.
     * Uses jQuery-ui autocomplete for the autocomplete.
     */
    searchAutocomplete() {

        /**
         * Set local data to search array results.
         * note: LocalData is passed to javascript with wp-localize-script in setup.php.
         */
        let searchArray;
        try {
            searchArray = $.parseJSON( Autocomplete.search_results );
        } catch ( e ) {

            // Failed to load the data.
            console.log( 'An error occurred loading the autocomplete data.' );
            return;
        }

        // Set element to variable to use it inside autocomplete.
        /* var searchForm = this.searchFormDesktop; */

        // Init jQuery autocomplete.
        this.searchFormInput.autocomplete({
            source: searchArray,
            delay: 0,
            minLength: 3,
            select: ( e, ui ) =>  {

                $( this.searchFormInput ).val( ui.item.label );

                // Submit the form.
                this.searchFormDesktop.submit();

            }
        });
    }

    /**
     * This is called by the Theme class.
     */
    docReady() {
        this.cache();

        // Uncomment when the autocomplete functionality is implemented.
        // this.searchAutocomplete();
    }

}
